import React, { Component } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { CloseModalContext } from 'common/containers/ModalContainer';
import Form from 'common/Form';
import Button from 'common/inputs/Button';
import TextInput from 'common/inputs/TextInput';
import withContexts from 'common/util/withContexts';

import Modal from './Modal';

import 'css/components/modals/_InputModal.scss';

class InputModal extends Component {
  static propTypes = {
    className: PropTypes.string,
    closeModal: PropTypes.func.isRequired,
    defaultValue: PropTypes.string,
    description: PropTypes.element,
    inset: PropTypes.string,
    onCancel: PropTypes.func,
    onValue: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    defaultValue: '',
    inset: 'Value',
    placeholder: '',
  };

  state = {
    value: this.props.defaultValue,
  };

  onChange = (e) => {
    const { value } = e.target;
    this.setState({
      value,
    });
  };

  onCancel = () => {
    const { closeModal, onCancel } = this.props;
    closeModal();
    if (onCancel) {
      onCancel();
    }
  };

  onDone = (e) => {
    e.preventDefault();

    const { value } = this.state;
    if (!value) {
      return;
    }

    const { closeModal, onValue } = this.props;
    closeModal();
    onValue(value);
  };

  render() {
    const { className, description, inset, placeholder } = this.props;
    const { value } = this.state;
    return (
      <Modal className={classnames(className)}>
        {description ? description : null}
        <Form
          className="inputModal"
          addEventsToDocument={false}
          disableSubmit={!value}
          onSubmit={this.onDone}>
          <TextInput
            autoFocus={true}
            inset={inset}
            onChange={this.onChange}
            placeholder={placeholder}
          />
          <div className="buttons">
            <Button buttonType="ghostButton" onTap={this.onCancel} value="Cancel" />
            <Button
              buttonType="cannyButton"
              disabled={!value}
              formButton={true}
              tint={true}
              value="Done"
            />
          </div>
        </Form>
      </Modal>
    );
  }
}

export default withContexts(
  {
    closeModal: CloseModalContext,
  },
  { forwardRef: true },
)(InputModal);
